import React, { useState } from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SelectCategoryTab from "../selectCategoryTab/selectCategoryTab";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SearchIcon from "@mui/icons-material/Search";
import SearchField from "../../../../../../../../../../customComponent/searchField/searchField";

const ServiceTable = ({
  onSelectService,
  onSelectServiceId,
  categoryList,
  serviceList,
  fetchServices,
  setServiceList,
  onServiceFormEdit,
  onDelete,
  setCategoryId,
  setCategoryImport,
}) => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedServiceDelete, setSelectedServiceDelete] = useState(null);

  const handleDeleteClick = (service) => {
    setShowDeletePopup(true);
    setSelectedServiceDelete(service);
  };
  const confirmDelete = () => {
    if (selectedServiceDelete) {
      onDelete(selectedServiceDelete.id, selectedServiceDelete.category_id);
      setSelectedServiceDelete(null);
    }
  };
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredService = serviceList.filter((service) =>
    service.service.toLowerCase().includes(searchValue.toLocaleLowerCase())
  );



  const displayService = searchValue ? filteredService : serviceList;

  
  const serviceWithIndex = displayService.map((service, index) => ({
    ...service,
    displayIndex: index + 1, 
  }));

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "Service ID", width: 90 },
    { field: "service", headerName: "Service Name", width: 270 },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      renderCell: (params) => (
        <div className="action-btn">
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={(event) => {
              event.stopPropagation();
              onSelectService(params);
              onSelectServiceId(params.row.id);
            }}
          >
            <VisibilityIcon />
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ marginRight: "5px" }}
            onClick={(event) => {
              event.stopPropagation();
              onServiceFormEdit(params);
              onSelectServiceId(params.row.id);
            }}
          >
            <EditIcon />
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDeleteClick(params.row);
            }}
          >
            <DeleteIcon />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
     <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <SelectCategoryTab
          fetchServices={fetchServices}
          categoryList={categoryList}
          setServiceList={setServiceList}
          setCategoryImport={setCategoryImport}
        />
        {serviceList.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <Typography variant="body1" color="textSecondary">
              No service under this category
            </Typography>
          </Box>
        ) : (
          <DataGrid
            className="mt-3"
            rows={serviceWithIndex}
            columns={columns}
            disableSelectionOnClick
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
          />
        )}
        {selectedServiceDelete && (
          <Dialog
            open={showDeletePopup}
            onClose={() => setShowDeletePopup(false)}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Do you really want to delete?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ textTransform: "none" }}
                onClick={confirmDelete}
              >
                Delete
              </Button>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                  color: "grey",
                  outline: "1px solid grey",
                }}
                onClick={() => setShowDeletePopup(false)}
              >
                cancel
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Box>
    </>
  );
};

export default ServiceTable;
